import {
  SET_SHOULD_FETCH_ESSENTIAL_DATA,
  SET_ACTION_STATUS,
  RESET_ACTION_STATUSES,
  SET_LAST_SYNC_TIMESTAMP,
} from 'constants/essentialData';
import { RootState } from 'reducers';
import { TYPE_LOGOUT } from 'constants/Login';
import * as dataKeys from 'containers/EssentialDataLoader/constants';
import { ActionStatus } from 'containers/EssentialDataLoader/types';

type SetShouldFetchEssentialDataAction = {
  type: typeof SET_SHOULD_FETCH_ESSENTIAL_DATA;
  payload: boolean;
};

type SetStatusAction = {
  type: typeof SET_ACTION_STATUS;
  payload: ActionStatus;
};

type ResetActionStatusesAction = {
  type: typeof RESET_ACTION_STATUSES;
};

type SetLastSyncTimestampAction = {
  type: typeof SET_LAST_SYNC_TIMESTAMP;
  payload: number;
};

type Action =
  | SetShouldFetchEssentialDataAction
  | SetStatusAction
  | ResetActionStatusesAction
  | SetLastSyncTimestampAction;

type State = {
  shouldFetchEssentialData: boolean;
  actionStatuses: ActionStatus[];
  /** Timestamp in seconds */
  lastSyncTimeStamp: number;
};

const initialActionStatuses = Object.keys(dataKeys).map(key => ({
  key,
  status: null,
})) as ActionStatus[];

const initialState: State = {
  shouldFetchEssentialData: false,
  actionStatuses: initialActionStatuses,
  lastSyncTimeStamp: 0,
};

export default function reducer(state = initialState, action: Action) {
  switch (action.type) {
    case SET_SHOULD_FETCH_ESSENTIAL_DATA:
      return {
        ...state,
        shouldFetchEssentialData: action.payload,
      };
    case SET_ACTION_STATUS:
      return {
        ...state,
        actionStatuses: state.actionStatuses.map(status => {
          if (status.key === action.payload.key) {
            return action.payload;
          }
          return status;
        }),
      };
    case RESET_ACTION_STATUSES:
      return {
        ...state,
        actionStatuses: initialState.actionStatuses,
      };
    case SET_LAST_SYNC_TIMESTAMP:
      return {
        ...state,
        lastSyncTimeStamp: action.payload,
      };
    case TYPE_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function getShouldFetchEssentialData(state: RootState) {
  return state.essentialData.shouldFetchEssentialData;
}

export function getActionStatuses(state: RootState) {
  return state.essentialData.actionStatuses;
}

export function getIsLoadingEssentialData(state: RootState) {
  const actionStatuses = getActionStatuses(state);
  if (actionStatuses.length === 0) return false;

  return actionStatuses.some(actionStatus =>
    [null, 'LOADING'].includes(actionStatus.status),
  );
}

export function getLastSyncTimeStamp(state: RootState) {
  return state.essentialData.lastSyncTimeStamp;
}
